import merge from 'lodash/merge';
import {ThemeBuildType, ThemeVariablesType} from '@yosmanyga/theme';

const buildTheme: ThemeBuildType = (variables, parent) => {
    const {palette, radius} = variables as ThemeVariablesType;

    const local = {
        text: buildText(variables),
        button: buildButton(variables),
        button_progress: buildButtonProgress(variables),
        container: buildContainer(variables),
        anchor: buildAnchor(variables),
        input_wrapper: buildInputWrapper(variables),
        input_entry: buildInputEntry(variables),
        icon: {
            color: palette.neutral['1000'],
            // width: 35,
            danger_intent: {
                color: palette.negative['500'],
            },
            success_intent: {
                color: palette.positive['500'],
            },
            // error_intent: {
            //     color: 'white'
            // }
        },
        progress: {
            width: 20,
            color: palette.neutral['1000'],
        },
        country_picker: buildCountryPicker(variables),
    };

    return merge(
        {},
        parent ? parent(variables) : {},
        local,
    );
};

const buildText = (variables?: ThemeVariablesType) => {
    const {font, palette} = variables as ThemeVariablesType;

    return {
        font: {
            family: "Fortaleza",
            size: font('100%'),
        },
        color: palette.neutral['1000'],
        title_intent: {
            font: {
                size: font('150%'),
            },
        },
        secondary_intent: {
            color: palette.neutral['600'],
            font: {
                size: font('80%'),
            },
        },
        danger_intent: {
            color: palette.negative['500'],
        },
        success_intent: {
            color: palette.positive['500'],
        },
        badge_intent: {
            color: 'blue',
        },
    };
};

const buildButton = (variables?: ThemeVariablesType) => {
    const {palette, radius} = variables as ThemeVariablesType;

    const text = buildText(variables);

    return {
        font: {
            ...text.font,
        },
        color: palette.neutral['950'],
        background: 'transparent',
        padding: 1,
        border: 0,
        pseudo: {
            hover: {
                color: palette.neutral['1000'],
                background: 'transparent',
                border: 0,
            }
        },
        is_disabled: {
            color: palette.neutral['700'],
            background: 'transparent',
            border: 0,
            pseudo: {
                hover: {
                    color: palette.neutral['900'],
                    background: 'transparent',
                    border: {
                        width: 0,
                        color: palette.neutral['900']
                    },
                }
            }
        },
        primary_intent: {
            color: palette.brand1['0'],
        },
        secondary_intent: {
            border: {
                color: palette.neutral['200'],
                width: 1,
                radius: 6,
            },
        },
        active_intent: {
            background: palette.neutral['100'],
            border: {
                radius: radius,
                width: 0,
            },
            pseudo: {
                hover: {
                    background: palette.neutral['200'],
                }
            }
        },
    };
};

const buildButtonProgress = (variables?: ThemeVariablesType) => {
    const {palette} = variables as ThemeVariablesType;

    return {
        color: palette.neutral['1000'],
        width: 20,
        negative_intent: {
            color: palette.neutral['0'],
        }
    };
};

const buildContainer = (variables?: ThemeVariablesType) => {
    const {palette, radius} = variables as ThemeVariablesType;

    return {
        modal_body_intent: {
            flow: 'column',
            margin: {
                left: 4,
                right: 4,
                top: 4,
            },
            padding: 2,
            background: palette.neutral['0'],
            border: {
                radius: 4,
            },
        },
        card_intent: {
            background: 'rgba(52, 52, 52, 0.1)',
            padding: 4,
            border: {
                width: 1,
                color: palette.neutral['100'],
                radius: radius,
            },
        },
        menu_title_intent: {
            flow: 'column',
            align: {
                cross: 'center',
            }
        },
        item_intent: {
            cursor: 'pointer',
        }
    };
};

const buildAnchor = (variables?: ThemeVariablesType) => {
    const {palette} = variables as ThemeVariablesType;

    const button = buildButton(variables);

    return {
        ...button,
        background: palette.neutral['100'],
        border: {
            color: palette.neutral['200'],
            width: 1,
            radius: 6,
        },
        pseudo: {
            hover: {
                background: palette.neutral['200'],
                border: {
                    color: palette.neutral['300'],
                },
            }
        }
    };
};

const buildInputEntry = (variables?: ThemeVariablesType) => {
    const {palette} = variables as ThemeVariablesType;

    const text = buildText(variables);

    return {
        font: text.font,
        color: palette.neutral['1000'],
        background: 'transparent',
        line: 1.5,
        is_multi: {
            line: 'inherit',
        },
        padding: 0.5,
    };
};

const buildInputWrapper = (variables?: ThemeVariablesType) => {
    const {palette} = variables as ThemeVariablesType;

    return {
        padding: 1,
        border: {
            color: palette.neutral['1000'],
            width: 1,
            radius: 6,
        },
    }
}

const buildCountryPicker = (variables?: ThemeVariablesType) => {
    const inputWrapper = buildInputWrapper(variables);

    return {
        country_intent: {
            ...inputWrapper
        }
    }
};

export {
    buildTheme
}